export function closeForm (state) {
	state.event = {};

	state.isFormOpen = false;
}
